/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "js-yaml", "react", "./PodContentReader"], function (require, exports, JsYaml, React, PodContentReader_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PodYaml = /** @class */ (function (_super) {
        __extends(PodYaml, _super);
        function PodYaml() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        PodYaml.prototype.render = function () {
            return (React.createElement(PodContentReader_1.PodContentReader, { className: "pod-yaml", contentClassName: "pod-yaml-content", text: JsYaml.safeDump(this.props.pod), markTTICallback: this.props.markTTICallback }));
        };
        return PodYaml;
    }(React.Component));
    exports.PodYaml = PodYaml;
});
